import {
  VContainer,
  VRow,
  VCol,
  VSelect,
  VTextField,
  VBtn,
  VCheckbox,
} from "vuetify/lib";
import { SPULevel, flowStatus, devStatus, trackList, SPU_TYPE, SPU_VERSION_TYPE } from "../constants";
import { getEnumConfigListApi } from "../service";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      search: {
        company_level: "",
        status: "",
        sub_status: "",
        track: "",
        team_id: "",
        product_family: "",
        business_unit: "",
        search: "",
        pending: false,
        type: "",
        edition: ""
      },
      pfList: [],
      buList: [],
      spu: [],
    };
  },
  computed: {
    ...mapGetters({
      companies: "async/companies",
      companies_hash: "async/companies_hash",
      teams: "async/root_teams",
      teams_hash: "async/root_teams_hash",
    }),
    myCount() {
      return this.$store.state.red_dot_hash["cya_spu_application"] || 0;
    },
  },
  watch: {
    ["search.pending"](v) {
      console.log(v);
      this.onSearch();
    },
  },
  mounted() {
    if (this.myCount && this.myCount > 0) {
      this.search.pending = true;
    }
    getEnumConfigListApi({ enum_type: "pf", del: false }).then((res) => {
      res = res || [];
      this.pfList = res.map((item) => item.enum_value);
    });
    getEnumConfigListApi({ enum_type: "bu", del: false }).then((res) => {
      res = res || [];
      this.buList = res.map((item) => item.enum_value);
    });
  },
  methods: {
    onSearch() {
      this.$emit("search", this.search);
    },
  },
  render() {
    return (
      <div>
        <VContainer fluid>
          <VRow align="center">
            <VCol>
              <VSelect
                items={SPULevel}
                label="SPU等级"
                v-model={this.search.company_level}
                item-text="label"
                item-value="value"
                clearable
              ></VSelect>
            </VCol>
            <VCol>
              <VSelect
                items={flowStatus}
                label="流程状态"
                v-model={this.search.status}
                item-text="label"
                item-value="value"
                clearable
              ></VSelect>
            </VCol>

            {this.search.status === flowStatus[0].value && (
              <VCol>
                <VSelect
                  items={devStatus}
                  label="研发状态"
                  v-model={this.search.sub_status}
                  item-text="label"
                  item-value="value"
                  clearable
                ></VSelect>
              </VCol>
            )}
            <VCol>
              <VSelect
                items={trackList}
                label="赛道"
                v-model={this.search.track}
                clearable
              ></VSelect>
            </VCol>
            <VCol>
              <VSelect
                items={SPU_TYPE}
                label="类型"
                v-model={this.search.type}
                clearable
                item-text="label"
                item-value="value"
              ></VSelect>
            </VCol>
            <VCol>
              <VSelect
                items={SPU_VERSION_TYPE}
                label="版本"
                v-model={this.search.edition}
                clearable
                item-text="label"
                item-value="value"
              ></VSelect>
            </VCol>
            <VCol>
              <VSelect
                items={this.teams}
                label="项目组"
                item-text="name"
                item-value="id"
                v-model={this.search.team_id}
                clearable
              ></VSelect>
            </VCol>
            <VCol>
              <VSelect
                items={this.pfList}
                label="PF"
                v-model={this.search.product_family}
                clearable
              ></VSelect>
            </VCol>
            <VCol>
              <VSelect
                items={this.buList}
                label="BU"
                v-model={this.search.business_unit}
                clearable
              ></VSelect>
            </VCol>
          </VRow>
          <VRow align="center">
            <VCol cols="3">
              <VTextField label="搜索关键词" v-model={this.search.search} />
            </VCol>
            <VCol style="display: flex; align-items: center;">
              <VBtn
                color="primary"
                elevation="2"
                onClick={() => {
                  this.onSearch();
                }}
              >
                搜索
              </VBtn>
              <VBtn
                color="primary"
                elevation="2"
                style="margin-left: 20px;"
                onClick={() => {
                  this.$emit("add");
                }}
              >
                新建SPU
              </VBtn>
              <VCheckbox
                label="待我处理"
                style="margin-left: 20px;"
                v-model={this.search.pending}
              ></VCheckbox>
            </VCol>
          </VRow>
        </VContainer>
      </div>
    );
  },
};
